import { Box, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useCallback } from "react";
import { Navigate, Outlet, useLocation, useMatch, useNavigate } from "react-router-dom";

function getCurrentView(pathname: string): string {
  if (pathname.includes("/steers")) return "steers";
  if (pathname.includes("/rcra-info")) return "rcra-info";
  return "epcra";
}

export function CredentialsDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const epcraMatch = useMatch("/staff/credentials/epcra/:credentialImplementationId?");
  const rcraMatch = useMatch("/staff/credentials/rcra-info");
  const steersMatch = useMatch("/staff/credentials/steers");
  const isOverview = epcraMatch ?? rcraMatch ?? steersMatch;

  useBreadcrumb({
    label: "Credentials",
    to: "/staff/credentials",
  });

  const currentView = getCurrentView(location.pathname);

  const handleViewChange = useCallback(
    (_event: React.MouseEvent<HTMLElement>, newView: string | null) => {
      if (!newView) return;
      navigate(`/staff/credentials/${newView}`);
    },
    [navigate]
  );

  if (!isOverview && location.pathname === "/staff/credentials") {
    return <Navigate to="/staff/credentials/epcra" replace />;
  }

  return (
    <Box>
      {isOverview && (
        <Stack
          sx={{
            backgroundColor: "background.paper",
            borderBottom: "1px solid",
            borderBottomColor: "divider",
          }}
        >
          <ToggleButtonGroup
            value={currentView}
            exclusive
            onChange={handleViewChange}
            sx={{
              "& .MuiToggleButton-root": {
                border: "none",
                borderRadius: 0,
                color: "text.secondary",
                pb: 1.5,
                px: 3,
                mr: 3,
                "&.Mui-selected": {
                  color: "primary.main",
                  backgroundColor: "transparent",
                  borderBottom: "3px solid",
                  borderBottomColor: "primary.main",
                },
              },
            }}
          >
            <ToggleButton value="epcra">EPCRA Credential Management</ToggleButton>
            <ToggleButton value="rcra-info">RCRAInfo Credentials</ToggleButton>
            <ToggleButton value="steers">STEERS Credentials</ToggleButton>
          </ToggleButtonGroup>
        </Stack>
      )}
      <Outlet />
    </Box>
  );
}
